﻿export class SaveInvoiceDataModel {
    public personalInvoice: boolean;
    public companyName : string;
    public nip : string;
    public street : string;
    public building : string;
    public apartment : string;
    public postalCode : string;
    public city : string;
}